import { reducer as ticketsReducer } from '../../home/ducks/tickets'

export {
  getTicketsFromRedux,
  setCategoryInRedux,
} from '../../home/ducks/tickets'

export const reducer = ticketsReducer
